import { useState } from "react";
import { Link } from "react-router-dom";
import { Crown, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const isPremiumUser = (user) =>
  user?.subscription_plan === "premium" ||
  (user?.premium_until && new Date(user.premium_until) > new Date());

export const UpgradeBanner = () => {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("zuntria_upsell_hidden") === "1");

  if (!user || isPremiumUser(user) || hidden) return null;

  const dismiss = () => {
    sessionStorage.setItem("zuntria_upsell_hidden", "1");
    setHidden(true);
  };

  return (
    <div className="mt-4 flex items-center justify-between gap-3 rounded-2xl border border-amber-500/40 bg-gradient-to-r from-amber-500/10 via-card to-card px-5 py-3.5" data-testid="upgrade-banner">
      <div className="flex items-center gap-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-amber-500/15 text-amber-500">
          <Crown className="h-4 w-4" />
        </span>
        <div className="text-sm">
          <span className="font-medium">Go Pro</span>
          <span className="text-muted-foreground"> — unlimited AI chats, 2× points & cashback, priority generation. </span>
          <span className="font-medium text-amber-500">£14.99/mo</span>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <Link to="/pricing" className="rounded-full bg-amber-500 px-4 py-1.5 text-xs font-semibold text-amber-950 transition-colors hover:bg-amber-400" data-testid="upgrade-banner-cta">
          Upgrade
        </Link>
        <button onClick={dismiss} className="rounded-md p-1.5 text-muted-foreground hover:text-foreground" data-testid="upgrade-banner-dismiss" aria-label="Dismiss">
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};
